export const SET_IS_LOGGED_IN = "SET_IS_LOGGED_IN";
export const SET_USER = "SET_USER";
export const SET_INITIAL_DATA = "SET_INITIAL_DATA";
export const RESET_STORE = "RESET_STORE";
